module.exports = __webpack_public_path__ + "97ffa1e755851a178bc0cfc105a28af8.pdf";